export const mapAndUpdateInitialValuesFromQueryParams = (
  identifier,
  initialValues,
  searchParams
) => {
  // map and update initialValues from url query params
  const fieldMappings = {
    zielone_szkoly: {
      school_nip: 'nip',
      school_street_address: 'street',
      school_postal_code: 'postal_code',
      school_city: 'city_name',
      office_representative_name: 'name',
      office_representative_surname: 'surname',
      office_representative_phone: 'phone',
      period_from: 'period_from',
      period_to: 'period_to',
      notes: 'notes'
    },
    wyjazdy_rodzinne: {
      period: '',
      guardian_name: 'name',
      guardian_surname: 'surname',
      guardian_phone: 'phone',
      guardian_correspondence_email: 'email',
      source_of_offer: 'zs_source_of_offer', // TODO
      wr_additional_order_info: 'notes',
      wr_adults_count: 'guardians_count'
    }
  };

  const mappings = fieldMappings[identifier];
  if (!mappings) {
    return;
  }

  Object.entries(mappings).forEach(([key, param]) => {
    const value = searchParams.get(param);
    if (value) {
      initialValues[key] = value;
    }
  });
};

export function processChildrenParam(childrenParam) {

  const wr_0_3_children_count = [];
  const wr_3_12_children_count = [];
  const wr_0_5_children_count = [];
  const wr_6_plus_children_count = [];

  if (childrenParam) {
    try {
      const children = JSON.parse(decodeURIComponent(childrenParam));

      children.forEach(child => {
        const age = parseInt(child.participant_age, 10);
        if (age >= 0 && age <= 5) {
          wr_0_5_children_count.push({ 'Wiek dziecka': String(age) });
        } else {
          wr_6_plus_children_count.push({ 'Wiek dziecka': String(age) });
        }
      });
    } catch (error) {
      console.error('Błąd parsowania children param:', error);
    }
  }

  return { wr_0_5_children_count, wr_6_plus_children_count };
}

export const getClientInfo = () => {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
    return null; // np. w SSR (Next.js)
  }

  return {
    userAgent: navigator.userAgent || null,
    platform: navigator.platform || null,
    vendor: navigator.vendor || null,
    language: navigator.language || (navigator.languages && navigator.languages[0]) || null,
    screen: {
      width: screen.width,
      height: screen.height
    },
    viewport: {
      width: window.innerWidth,
      height: window.innerHeight
    },
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
    hardwareConcurrency: navigator.hardwareConcurrency || null,
    deviceMemory: navigator.deviceMemory || null,
    cookieEnabled: navigator.cookieEnabled,
    // client hints (if dostępne)
    uaData: navigator.userAgentData ? {
      brands: navigator.userAgentData.brands,
      mobile: navigator.userAgentData.mobile,
      platform: navigator.userAgentData.platform
    } : null
  };
};
